import React from 'react'
import { observer } from 'mobx-react'
import { Modal, Table } from 'react-bootstrap'
import * as defaultConst from '../../../constants/default_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../../input/date'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectWithSuggestions from '../../input/select_suggested'
import TextField from 'react-mobx-admin/components/common/field/text'
import moment from 'moment'

export default observer(({ store }) => {
  if (!store.fp_pricings_copy_modal) {
    return null
  }

  const state = store.cv.subentities.FPPricingsCopy
  const dateRestriction = store.timeRestriction.flyprivate_video_pricing
  const updateFormField = store.updateSubentityField.bind(store, state, store.cv.items)
  const errors = state.errors
  const movie = state.record.get('movie')
  const controlTimestamp = Math.round(new Date().getTime())
  const fromDate = dateRestriction.valid_from.minDateTimeStart.clone().add(1, 'days').utcOffset(0)

  const pricings = state.record.get('pricings') &&
    state.record.get('pricings').filter(i =>
      moment(i.valid_to).utc().isSameOrAfter(fromDate, 'seconds')
    )
  const foundMovieData = pricings && pricings.length > 0

  const changeCheckbox = id => {
    const selection = state.record.get('selection')
    if (selection) {
      if (selection.includes(id)) {
        selection.splice(selection.indexOf(id), 1)
      } else {
        selection.push(id)
      }
    }
    store._runSubentityGlobalValidator(state)
  }

  const fetchData = () => {
    if (state.record.get('selection') && state.record.get('selection').length > 0) {
      for (const idx of state.record.get('selection')) {
        const i = pricings.find(c => c.id === idx)
        const newI = {
          control_timestamp: controlTimestamp + idx,
          regions: i.regions,
          flyprivate_platform_tier_pricing_id: i.flyprivate_platform_tier_pricing_id,
          fixed_tier: i.fixed_tier,
          quality_hd: i.quality_hd,
          quality_mobile: i.quality_mobile,
          quality_sd: i.quality_sd,
          quality_uhd: i.quality_uhd,
          coming_soon_flag: i.coming_soon_flag,
          prior_flag: i.prior_flag,
          utc_flag: i.utc_flag,
          valid_from: (state.record.has('valid_from') && state.record.get('valid_from')) ||
            (moment(i.valid_from).utc().isSameOrBefore(fromDate)
              ? fromDate.format(moment.defaultFormatUtc)
              : i.valid_from),
          valid_to: (state.record.has('valid_to') && state.record.get('valid_to')) || i.valid_to
        }

        store.cv.record.get('flyprivate_video_pricing').push(newI)
      }
    }
    closeModal()
  }

  const closeModal = () => {
    state.record.delete('movie')
    state.record.delete('fetchedMovie')
    state.record.delete('selection')
    state.record.delete('pricings')
    store.toggleFPPricingsCopyModal()
  }

  return (
    <Modal show backdrop='static' onHide={() => store.toggleFPPricingsCopyModal()}>
      <Modal.Header closeButton>
        <Modal.Title>
          {store.__('Copy pricings from another film')} vvvvv
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SelectWithSuggestions
          label={store.__('Film')}
          attr={'movie'}
          record={state.record}
          onChange={updateFormField}
          optionsrecord={store.options}
          optionsattr={'films'}
          labelattr='title'
          valueattr='id'
          errors={errors} />

        {foundMovieData
          ? <Table striped bordered condensed>
            <thead>
              <tr>
                <th />
                <th>{ store.__('ID') }</th>
                <th>{ store.__('platform') }</th>
                <th>{ store.__('sale type') }</th>
                <th>{ store.__('tier') }</th>
                <th>{ store.__('regions') }</th>
                <th>{ store.__('valid from') }</th>
                <th>{ store.__('valid to') }</th>
              </tr>
            </thead>
            <tbody>
              {pricings.map(c => (
                <tr key={c.id}>
                  <td><input onClick={_ => changeCheckbox(c.id)}
                    checked={state.record.get('selection') && state.record.get('selection').includes(c.id)}
                    type='checkbox'/></td>
                  <td><TextField val={c.id} /></td>
                  <td>
                    <OptionsField
                      val={c.flyprivate_platform_tier_pricing_id}
                      options={store.options.get('flyprivate_pricings')}
                      labelattr='platform'
                      valueattr='id'
                      Component={({ text }) => <OptionsField
                        val={text}
                        options={store.options.get('FlyPrivatePlatforms')}
                        labelattr='text'
                        valueattr='value' />}
                    />
                  </td>
                  <td>
                    <OptionsField
                      val={c.flyprivate_platform_tier_pricing_id}
                      options={store.options.get('flyprivate_pricings')}
                      labelattr='type_sale'
                      valueattr='id'
                      Component={({ text }) => <OptionsField
                        val={text}
                        options={store.options.get('VodSaleTypes')}
                        labelattr='text'
                        valueattr='value' />}
                    />
                  </td>
                  <td>
                    <OptionsField
                      val={c.flyprivate_platform_tier_pricing_id}
                      options={store.options.get('flyprivate_pricings')}
                      labelattr='tier'
                      valueattr='id'
                      Component={({ text }) => <OptionsField
                        val={text}
                        options={store.options.get('PricingTiers')}
                        long={true}
                        labelattr='text'
                        valueattr='value' />}
                    />
                  </td>
                  <td><TextField val={c.regions} textWidth='300px' /></td>
                  <td><DateField val={c.valid_from && moment(c.valid_from).utc().isSameOrBefore(moment().utc())
                    ? fromDate
                    : c.valid_from} showTime /></td>
                  <td><DateField val={c.valid_to} showTime /></td>
                </tr>
              ))
              }
            </tbody>
          </Table>
          : null
        }

        {foundMovieData
          ? <React.Fragment>
            <DateInput
              label={store.__('Valid from (override)')}
              attr={'valid_from'}
              record={state.record}
              onChange={updateFormField}
              errors={errors}
              minDate={dateRestriction.valid_from.minDate} />

            <DateInput
              label={store.__('Valid to (override)')}
              attr={'valid_to'}
              record={state.record}
              onChange={updateFormField}
              errors={errors}
              minDate={dateRestriction.valid_to.minDate} />
          </React.Fragment>
          : null
        }

        {movie && state.record.has('fetchedMovie') && !foundMovieData
          ? <div className='alert alert-warning fade in'>
            {store.__('No relevant data were found in selected movie')}
          </div>
          : null
        }

        {errors.has('_global') &&
          <div className='alert alert-danger fade in'>
            <strong>Error! </strong>
            {errors.get('_global')}
          </div>
        }

      </Modal.Body>
      <Modal.Footer>
        <div className='btn-group' role='group'>
          <button disabled={errors.size > 0 || !pricings || !foundMovieData} type='button' className='btn btn-primary'
            onClick={fetchData}>
            {store.__('Submit')}
          </button>
          <button type='button' className='btn btn-default'
            onClick={closeModal}>
            {store.__(defaultConst.TITLE_CANCEL)}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
})
